// extracted by mini-css-extract-plugin
export default {"host":"style_host__7Bo9B"};